import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

interface UnsubscribeParams {
  user: string;
  email: string;
  sender: string;
}

export const unsubscribe = async (
  data: UnsubscribeParams
): Promise<{ success: boolean }> => {
  const response = await EXPRESS_API.post('/opt-outs', data);

  return response.data;
};

export const useUnsubscribeMutation = () => {
  const { t } = useTranslation();

  return useMutation(unsubscribe, {
    onSuccess: () => {
      successToast({ title: t('You have been successfully unsubscribed.') });
    },
    onError: () => {
      errorToast({
        title: t('An error occurred while unsubscribing. Please try again.'),
      });
    },
  });
};
